<template>
  <div class="business">
    <common-layout>
      <div slot="header">
        <div class="business.tabs" v-if="!showKjcx">
          <span
            v-for="btn in tabs"
            :key="btn.id"
            @click="handleClick(btn.id)"
            :class="{ active_t: activeTab == btn.id }"
          >
            {{ btn.name }}
          </span>
        </div>
        <ul class="business.nav">
          <li>内容管理</li>
          <li class="active-Tab">业务办理</li>
        </ul>
      </div>
      <div slot="container">
        <template v-if="!showKjcx">
          <component
            v-for="(item, index) in apps"
            :is="item.app"
            v-if="index + 1 == activeTab"
            :key="index"
            ref="businessApps"
          ></component>
        </template>
        <template v-else>
          <component :is="require('./business/technologyInquiry.vue').default"></component>
        </template>
      </div>
    </common-layout>
  </div>
</template>

<script>
import CommonLayout from '../../components/common-layout.vue';
export default {
  components: {
    CommonLayout
  },
  data() {
    return {
      tabs: [
        {
          id: 1,
          name: '办理技术贸易资格证'
        },
        {
          id: 2,
          name: '年检技术贸易资格证'
        },
        {
          id: 3,
          name: '技术合同认定'
        },
        {
          id: 4,
          name: '技术经纪(经理)人培训'
        },
        {
          id: 5,
          name: '科技成果评价'
        },
        {
          id: 6,
          name: '科技查新'
        },
        {
          id: 7,
          name: '专家入库登记'
        },
        {
          id: 8,
          name: '企业创新积分'
        }
      ],
      activeTab: 1,
      apps: [],
      comps: [
        { name: 'newApply' },
        { name: 'yearApply' },
        { name: 'contract' },
        { name: 'manager' },
        { name: 'evaluation' },
        { name: 'technologyInquiry' },
        { name: 'expertInventoryRegistration' },
        { name: 'innovationPointsSystem' }
      ],
      showKjcx: false
    };
  },

  methods: {
    // 切换tab
    handleClick(val) {
      if (val == this.activeTab) return;
      const component = this.getActiveBusinessComponent();
      if (!component || !component.hasUnsavedChanges || !component.hasUnsavedChanges()) {
        this.switchTab(val);
        return;
      }
      this.$confirm('当前页面存在未保存的修改，确定离开吗？', '未保存变更', {
        confirmButtonText: '离开页面',
        cancelButtonText: '继续编辑',
        type: 'warning'
      }).then(() => this.switchTab(val)).catch(() => {});
    },
    getActiveBusinessComponent() {
      const components = this.$refs.businessApps;
      return Array.isArray(components) ? components[0] : components;
    },
    switchTab(val) {
      this.activeTab = val;
      localStorage.setItem('tab', val);
    }
  },
  beforeRouteLeave(to, from, next) {
    const component = this.getActiveBusinessComponent();
    if (!component || !component.hasUnsavedChanges || !component.hasUnsavedChanges()) {
      next();
      return;
    }
    this.$confirm('当前页面存在未保存的修改，确定离开吗？', '未保存变更', {
      confirmButtonText: '离开页面',
      cancelButtonText: '继续编辑',
      type: 'warning'
    }).then(() => next()).catch(() => next(false));
  },
  created() {
    if (JSON.parse(this.$store.getters.userInfo).type === 8) {
      this.showKjcx = true;
    }
    this.comps.forEach(app => {
      this.apps.push({ app: require(`./business/${app.name}.vue`).default, url: app.url });
    });
    if (localStorage.getItem('tab')) {
      this.activeTab = localStorage.getItem('tab');
    }
  }
};
</script>

<style lang="scss" scoped>
@include component(business) {
  height: 100%;
  @include part(tabs) {
    width: 750px;
    height: 50px;
    border: 1px solid #ef9f49;
    display: flex;
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;

    > span {
      display: inline-block;
      width: 150px;
      height: 50px;
      line-height: 50px;
      font-weight: bold;

      &.active_t {
        background: linear-gradient(to bottom right, #fbc434 0%, #f66b4e 100%);
        color: #fff;
      }
    }
  }
  @include part(nav) {
    display: flex;
    align-items: center;
    justify-content: space-between;

    li {
      &.active-Tab {
        color: rgba(255, 255, 255, 0.4);

        &:before {
          display: inline-block;
          padding-right: 0.5rem;
          padding-left: 0.5rem;
          color: rgba(255, 255, 255, 0.4);
          content: '/';
        }
      }
    }
  }
}
</style>
